import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Button from '../Button';
import StackView from '../StackView';
import { useHover } from '../hooks';

function ListItem(_ref) {
  var children = _ref.children,
      onRemoveRequest = _ref.onRemoveRequest,
      _ref$removeTitle = _ref.removeTitle,
      removeTitle = _ref$removeTitle === void 0 ? 'Remove item' : _ref$removeTitle,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "onRemoveRequest", "removeTitle"]);

  var _useHover = useHover(),
      hover = _useHover.hover,
      hoverProps = _useHover.hoverProps;

  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    alignment: "center",
    distribution: "space-between",
    padding: 1,
    backgroundColor: "surface"
  }, hoverProps, restProps), children, onRemoveRequest && /*#__PURE__*/React.createElement(Button, {
    icon: {
      name: 'remove-circle-filled'
    },
    title: removeTitle,
    size: "sm",
    theme: "error",
    variant: "naked",
    marginLeft: 1,
    opacity: hover ? 1 : 0,
    onClick: onRemoveRequest
  }));
}

export default ListItem;